export const ERROR_MESSAGES = "This field is required.";
export const OutBooksTitle = "Outbooks Proposal"
export const SAPredefinedChangesNotifyMessage = "System administrator made some changes, please accept or decline."
